import { render, staticRenderFns } from "./AppHeaderConnectWallet.vue?vue&type=template&id=0aea8be4&scoped=true"
import script from "./AppHeaderConnectWallet.vue?vue&type=script&lang=js"
export * from "./AppHeaderConnectWallet.vue?vue&type=script&lang=js"
import style0 from "./AppHeaderConnectWallet.vue?vue&type=style&index=0&id=0aea8be4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aea8be4",
  null
  
)

export default component.exports